import * as React from 'react';

import { Page, PageContent, PageHeader } from '../../components/common';

interface Props {
	actions: any;
	history: any;
}
class GroupDetailPage extends React.Component<Props, any> {
	render() {
		return (
			<Page title="Group X">
				<PageContent>
					<PageHeader title="Group X Details" className="page-header-sm" />
					Content goes here
				</PageContent>
			</Page>
		);
	}
}
export default GroupDetailPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/groups/GroupDetailPage.tsx